
 <v-form ref="form">
     <v-row class="no-frame mt-3">
         <v-col class="no-frame pr-1">
             <v-text-field
                 label="Name"
                 v-model="user.firstname"
                 autocomplete   = "off"
                 autocorrect    = "off"
                 autocapitalize = "off"
                 spellcheck     = "false"
             />
         </v-col>
         <v-col class="no-frame pl-1">
             <v-text-field
                 label="Name"
                 v-model="user.lastname"
                 autocomplete   = "off"
                 autocorrect    = "off"
                 autocapitalize = "off"
                 spellcheck     = "false"
                 :rules         = "[requiredRule]"
             />
         </v-col>
     </v-row>
     <v-row class="no-frame">
         <v-col class="no-frame">
             <f-enum-select
                 label        = "Niederlassung"
                 v-model      = "user.branch"
                 module       = "msd"
                 type         = "branches"
             />
         </v-col>
     </v-row>
     <v-row class="no-frame">
         <v-col class="no-frame pr-2">
             <v-text-field
                 label="Telefon"
                 v-model="user.phone"
                 autocomplete   = "off"
                 autocorrect    = "off"
                 autocapitalize = "off"
                 spellcheck     = "false"
                 :rules         = "[requiredRule]"
             />
         </v-col>
         <v-col class="no-frame pl-2">
             <v-text-field
                 label="Mobil"
                 v-model="user.mobile"
                 autocomplete   = "off"
                 autocorrect    = "off"
                 autocapitalize = "off"
                 spellcheck     = "false"
             />
         </v-col>
     </v-row>
     <v-row class="no-frame">
         <v-col class="no-frame pr-2">
             <v-text-field
                 label="FAX"
                 v-model="user.fax"
                 autocomplete   = "off"
                 autocorrect    = "off"
                 autocapitalize = "off"
                 spellcheck     = "false"
             />
         </v-col>
         <v-col class="no-frame pl-2">
             <v-text-field
                 label="Email"
                 v-model="user.email"
                 autocomplete   = "off"
                 autocorrect    = "off"
                 autocapitalize = "off"
                 spellcheck     = "false"
                 :rules         = "[requiredRule]"
             />
         </v-col>
     </v-row>

     <v-row class="no-frame">
         <v-col class="no-frame pr-2">
             <v-switch
                 label="Backoffice"
                 v-model="user.boUser"
             />
         </v-col>
         <v-col class="no-frame pl-2">
         </v-col>
     </v-row>
</v-form>
